import axios from "@/libs/api.request";
// 获取应收报表列表
export const getPacketReport = params => {
  return axios.request({
    url: "/report/bag/summary",
    method: "get",
    params
  });
};
